export default __webpack_public_path__ + "static/media/fullimage.81dfe46d.svg";